"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionsFirestore = void 0;
class SectorsFirestore {
    constructor(rawFirestore) {
        this.rawFirestore = rawFirestore;
        // construct
    }
    getSkills(version, sector) {
        return this.rawFirestore.getSectorSkills(version, sector);
    }
    setSkills(version, sector, skills) {
        return this.rawFirestore.setSectorSkills(version, sector, skills);
    }
    getWorkCareerTree(version, sector) {
        return this.rawFirestore.getCareerTree(version, sector);
    }
    setWorkCareerTree(version, sector, careerTree) {
        return this.rawFirestore.setCareerTree(version, sector, careerTree);
    }
    getWorkCompanies(version, sector) {
        return this.rawFirestore.getCompanies(version, sector);
    }
    setWorkCompanies(version, sector, companies) {
        return this.rawFirestore.setCompanies(version, sector, companies);
    }
    getWorkHighestPositions(version, sector) {
        return this.rawFirestore.getHighestPositions(version, sector);
    }
    setWorkHighestPositions(version, sector, highestPositions) {
        return this.rawFirestore.setHighestPositions(version, sector, highestPositions);
    }
    getWorkJobDescription(params) {
        return this.rawFirestore.getJobDescription(params);
    }
    setWorkJobDescription(params, data) {
        return this.rawFirestore.setJobDescription(params, data);
    }
    getWorkJobSalary(params) {
        return this.rawFirestore.getJobSalary(params);
    }
    setWorkJobSalary(params, data) {
        return this.rawFirestore.setJobSalary(params, data);
    }
    getWorkJobQuestions(params) {
        return this.rawFirestore.getJobQuestions(params);
    }
    setWorkJobQuestions(params, data) {
        return this.rawFirestore.setJobQuestions(params, data);
    }
    getWorkJobSkills(params) {
        return this.rawFirestore.getJobSkills(params);
    }
    setWorkJobSkills(params, data) {
        return this.rawFirestore.setJobSkills(params, data);
    }
}
class VersionsFirestore {
    constructor(rawFirestore) {
        this.rawFirestore = rawFirestore;
        this.sectors = new SectorsFirestore(rawFirestore);
    }
    getVersion(version) {
        return this.rawFirestore.getVersion(version);
    }
    updateVersion(version, data) {
        return this.rawFirestore.updateVersion(version, data);
    }
    listenVersion(version, onNext) {
        return this.rawFirestore.listenVersion(version, onNext);
    }
    updateLifeCards(version, data) {
        return this.rawFirestore.updateLifeCards(version, data);
    }
    getAllSkills(version) {
        return this.rawFirestore.getAllSkills(version);
    }
    updateAllSkills(version, data) {
        return this.rawFirestore.updateAllSkills(version, data);
    }
    getValues(version) {
        return this.rawFirestore.getValues(version);
    }
    setValues(version, data) {
        return this.rawFirestore.setValues(version, data);
    }
    getCompanyValues(version) {
        return this.rawFirestore.getCompanyValues(version);
    }
    setCompanyValues(version, data) {
        return this.rawFirestore.setCompanyValues(version, data);
    }
    getEducationLevels(version) {
        return this.rawFirestore.getEducationLevels(version);
    }
    updateEducationLevels(version, data) {
        return this.rawFirestore.updateEducationLevels(version, data);
    }
    clearEducationQuestions(version) {
        return this.rawFirestore.clearEducationQuestions(version);
    }
    getEducationQuestions(version, part) {
        return this.rawFirestore.getEducationQuestions(version, part);
    }
    setEducationQuestions(version, part, data) {
        return this.rawFirestore.setEducationQuestions(version, part, data);
    }
    clearQuestionsAmounts(version) {
        return this.rawFirestore.clearQuestionsAmounts(version);
    }
    getQuestionsAmount(version, study) {
        return this.rawFirestore.getQuestionsAmount(version, study);
    }
    setQuestionsAmount(version, study, data) {
        return this.rawFirestore.setQuestionsAmount(version, study, data);
    }
}
exports.VersionsFirestore = VersionsFirestore;
